import {AjaxFactory, HttpMethod} from '../../_libs/redux-observable-list';
import {ReduxRequest} from '../../core-utilities/redux-request';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {getResetPassword} from '../reducers/state';
import {baseReduxRequestOptions} from './requests';
import {RESET_PASSWORD_PREFIX} from './state';

const reduxRequestOptions = {
  prefix: RESET_PASSWORD_PREFIX,
  getState: getResetPassword,
  requestFactory: buildSignupUserAjaxFactory({
    ...BASE_REDUX_LIST_OPTIONS,
  }),
  buildRequest: (state, payload) => payload,
  ...baseReduxRequestOptions,
};
/** @type {ReduxRequest} */
export const resetPasswordRequest = new ReduxRequest(reduxRequestOptions);

/**
 * Endpoint does not require an auth token for obvious reasons.
 * @param options
 * @return {AjaxFactory}
 */
function buildSignupUserAjaxFactory(options) {
  return new AjaxFactory({
    crossDomain: options.crossDomain,
    method: HttpMethod.POST,
    useBody: true,
    url: `${options.baseApiUrl}/auth/reset-password`,
    responseType: request => 'json',
  });
}



// WEBPACK FOOTER //
// ./src/js/auth/redux/resetPassword.js